import { LayoutSettingSelectedEventData } from '@databases/analytics/src/types';
import { DatabaseViewSettings } from '@databases/types/database/view';
import { ViewChangeType } from '@databases/utils/database/view/view';
import React, { FunctionComponent } from 'react';

import CardWidthSetting from './CardWidthSetting';
import CoverImageSetting from './CoverImageSetting';

export interface CardLayoutOptionsProps {
  onChange: (delta: ViewChangeType) => void;
  FieldPicker: React.FunctionComponent<any>;
  contentId: string;
  layout: DatabaseViewSettings['layout'];
  source: LayoutSettingSelectedEventData['source'];
}

const CardLayoutOptions: FunctionComponent<CardLayoutOptionsProps> = ({
  onChange,
  FieldPicker,
  contentId,
  layout,
  source,
}) => {
  return (
    <>
      <CardWidthSetting
        onChange={onChange}
        value={layout}
        contentId={contentId}
        source={source}
      />
      <CoverImageSetting
        contentId={contentId}
        value={layout}
        onChange={onChange}
        FieldPicker={FieldPicker}
        source={source}
      />
    </>
  );
};

export default CardLayoutOptions;
